import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function HomeTrending2() {
  const [blog, setBlog] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://tamizhtechie-test.herokuapp.com/blog/")
      .then((res) => {
        setBlog(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const name = "trending";
  return (
    <div>
      <div className="trendinghero">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 ">
              {blog
                .filter((blog) => blog.category === name)
                .slice(-5, -1)
                .reverse()
                .map((values) => {
                  return (
                    <Link
                      to={{
                        pathname: "/blog" + "/" + values.slug,
                      }}
                    >
                      <div className="row mb-4">
                        <div className="col-5 item-zoom">
                          <img
                            src={values.imageUrl}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="col-7">
                          <h5 className="claimedRight">{values.title}</h5>
                          <h6>{values.date}</h6>
                        </div>
                      </div>
                    </Link>
                    // </a>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
